import type { ReactElement } from 'react';
import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { removeClubParis } from '@/modules/cart/infrastructure/CartReduxRepository/CartReduxRepository';
import { CardButton, ModalWrapper } from '@/modules/perseo-billing/components';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { setIsRemoveClubParisModalOpen } from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  CardHeader,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

export const ModalRemoveClubParis = (): ReactElement | null => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery('lg');
  const billing = useAppSelector((state) => state.billing);
  const { isRemoveClubParisModalOpen } = billing || {};

  const { sendClubParisRemovedGtm } = useGtmBillingProduct();
  const { data } = useAppSelector((state) => state.cart);
  const { clubParisCode = '' } = data || {};

  const sendSuccessfullRemovedClubParisGtm = () => {
    sendClubParisRemovedGtm(clubParisCode);
  };
  const handleRemoveClub = async (): Promise<void> => {
    dispatch(removeClubParis(sendSuccessfullRemovedClubParisGtm));
    dispatch(setIsRemoveClubParisModalOpen(false));
  };

  const modalContent = (
    <ModalWrapper
      size="sm"
      open={!!isRemoveClubParisModalOpen}
      onClose={() => dispatch(setIsRemoveClubParisModalOpen(false))}
      roundedType="FIXED_BOTTOM"
      fullWidth={isMobile}
    >
      <Card p={16}>
        <CardHeader
          pb={16}
          action={
            <div
              onClick={() => dispatch(setIsRemoveClubParisModalOpen(false))}
              className="co-cursor-pointer"
            >
              <Icon icon="CloseIcon" width={18} height={18} />
            </div>
          }
          title={
            <div className="co-flex co-gap-8px">
              <Icon
                icon="InputWarningIcon"
                width={24}
                height={24}
                className="co-min-w-24px co-min-h-24px"
              />
              <Typography size="h2" weight="semibold">
                ¿Quieres eliminar el código de beneficios?
              </Typography>
            </div>
          }
        />
        <Divider />
        <div className="co-flex co-flex-col co-gap-16px co-pt-32px">
          <CardButton
            fullWidth
            variant="contained"
            onClick={handleRemoveClub}
            loading={false}
            color="pds-error"
          >
            Eliminar
          </CardButton>
          <CardButton
            fullWidth
            rounded="full"
            variant="outlined"
            color="primary"
            onClick={() => dispatch(setIsRemoveClubParisModalOpen(false))}
          >
            Volver
          </CardButton>
        </div>
      </Card>
    </ModalWrapper>
  );

  const modalElement = document.getElementById('modal-club-paris-remove');

  return modalElement ? createPortal(modalContent, modalElement) : null;
};
